import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'

import {
    CATALOG_CREATE,
    CATALOG_FETCH
} from './types';

const removeOldFile = (src) => {
    var ref = firebase.storage().ref().child(src);
    // Delete the file
    ref.delete().then(() => {
        window.location = "/admin/catalog"
    }).catch((error) => {
        window.location = "/admin/catalog"
    });
}

export const catalogDeleteById = (id, file) => {
    return (dispatch) => {
        firebase.database().ref('catalogs/'+id).remove()
        .then(() => removeOldFile(file))
    }
}

export const catalogFetch = () => {
    return (dispatch) => {
        let	catalogsRef = firebase.database().ref('catalogs')
		catalogsRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                if( typeof item === 'object') {
                    data.push(item)
                }
			})
			dispatch({ type: CATALOG_FETCH, payload: data.reverse() });
		})
    }
}

export const catalogCreate = (data) => {
    return (dispatch) => {
        dispatch({ type: CATALOG_CREATE, payload: true })
        const filename = Date.now()+"."+data.file.name.split('.').pop()
        const storage = firebase.storage().ref()
        const fileRef = storage.child('catalog/'+filename)
        fileRef.put(data.file).then(()=>{
            fileRef.getDownloadURL().then((url) => {
                const catalogsRef = firebase.database().ref('catalogs').push()
                const id = catalogsRef.key
                data.id = id
                data.file = url
                catalogsRef.set(data)
                .then(response => {
                    window.location = "/admin/catalog"
                })
                .catch(err => {
                    console.log("catalogCreate", err)
                })

            }).catch((error) => {
                dispatch({ type: CATALOG_CREATE, payload: false })
                console.log('Fail to create catalog', error)
            })
        })
    }
}